import { useEffect, useRef, useState } from 'react';

const useVisualEffects = () => {
  const [flashType, setFlashType] = useState('');
  const [flashOn, setFlashOn] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [feedbackVisible, setFeedbackVisible] = useState(false);
  const [confetti, setConfetti] = useState([]);
  const [ripple, setRipple] = useState(null);

  const feedbackTimeoutRef = useRef(null);

  useEffect(
    () => () => {
      if (feedbackTimeoutRef.current) clearTimeout(feedbackTimeoutRef.current);
    },
    [],
  );

  const flash = (type) => {
    setFlashType(type);
    setFlashOn(true);
    setTimeout(() => setFlashOn(false), 180);
  };

  const showFeedback = (text) => {
    setFeedback(text);
    setFeedbackVisible(true);
    if (feedbackTimeoutRef.current) clearTimeout(feedbackTimeoutRef.current);
    feedbackTimeoutRef.current = setTimeout(() => setFeedbackVisible(false), 1600);
  };

  const confettiBurst = () => {
    const pieces = Array.from({ length: 18 }).map((_, i) => ({
      id: `${Date.now()}-${i}`,
      left: `${15 + Math.random() * 70}%`,
      top: `${18 + Math.random() * 8}%`,
      color: ['#ffd93d', '#ff8fab', '#7ee081', '#8ecbff'][i % 4],
      dx: `${(Math.random() * 2 - 1) * 220}px`,
      dy: `${130 + Math.random() * 200}px`,
      rot: `${(Math.random() * 2 - 1) * 540}deg`,
    }));
    setConfetti(pieces);
    setTimeout(() => setConfetti([]), 950);
  };

  const rippleFromEvent = (event) => {
    if (!event?.currentTarget?.getBoundingClientRect) return;
    const rect = event.currentTarget.getBoundingClientRect();
    setRipple({
      id: Date.now(),
      left: rect.left + rect.width / 2 - 6,
      top: rect.top + rect.height / 2 - 6,
    });
    setTimeout(() => setRipple(null), 700);
  };

  return {
    flash,
    showFeedback,
    confettiBurst,
    rippleFromEvent,
    flashType,
    flashOn,
    feedback,
    feedbackVisible,
    confetti,
    ripple,
  };
};

export default useVisualEffects;
